import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { AuthGuard } from './core/services/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'dashboard', canActivate: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: async () => (await import('./feature/dashboard/dashboard.component')).DashboardComponent
      }
    ],
    data: {
      selectedNavbarItem: 'dashboard'
    }
  },
  {
    path: 'okr', canActivate: [AuthGuard],
    component: MainLayoutComponent,
    loadChildren: () => import('./feature/okr/okr.routes'),
    data: {
      selectedNavbarItem: 'okr'
    }
  },
  {
    path: 'tasks', canActivate: [AuthGuard],
    component: MainLayoutComponent,
    loadChildren: () => import('./feature/tasks/task.routes'),
    data: {
      selectedNavbarItem: 'tasks'
    }
  },
  {
    path: 'documents', canActivate: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: async () => (await import('./feature/file-attachments/file-attachments.component')).FileAttachmentsComponent,
      }
    ],
    data: {
      selectedNavbarItem: 'documents'
    }
  },
  {
    path: '', canActivate: [AuthGuard],
    component: MainLayoutComponent,
    loadChildren: () => import('./feature/okr/okr.routes'),
    data: {
      selectedNavbarItem: 'okr'
    }
  },
  {
    path: '',
    component: MainLayoutComponent,
  },
  // { path: '**', redirectTo: '/dashboard', pathMatch: 'full' },
];
